/* Confirmation popups (snippets/popup-contact-confirmation.liquid and
   popup-subscription-confirmation.liquid). Loaded once from
   layout/theme.liquid after ac-cart.js.

   The theme's module.popup-subscription-confirmation.js still decides when
   a confirmation shows: it reads Shopify's own redirect flags
   (?contact_posted=true after an accepted contact post, ?customer_posted=true
   after an accepted newsletter signup) or the hidden server error list a
   rejected signup re-renders, opens the matching popup, and strips the
   flag from the URL on close so a reload does not reopen it. This file
   adds three things around that:

   - the theme only fetches its scripts, that module included, on the
     first mouse move or touch, so after a form post the confirmation used
     to wait for one; on a posted page the loader is nudged at DOMContent-
     Loaded instead
   - each popup is a modal dialog through the registry in ac-cart.js
     (focus to Close, Tab cycles inside, page inert, chat bubble hidden,
     focus back to the opener or, after a redirect, to the form that posted)
   - the dialog's accessible name and description follow whichever block
     is showing, success or error */
(function () {
  'use strict';

  var POSTED = /[?&]contact_posted=true|[?&]customer_posted=true|contact%5Btags%5D=newsletter&form_type=customer/;

  /* Deferred scripts run before DOMContentLoaded; check now and again then,
     so a marker that arrives with the rest of the document is not missed. */
  function onReady(fn) {
    fn();
    if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', fn);
  }

  function hasErrorMarker() {
    return !!document.querySelector('.js-subscription-confirmation-error, [data-js-popup-name="message"] .note--error');
  }

  /* ---- load the theme's confirmation module ------------------------------ */

  var loader = window.theme && theme.AssetsLoader;
  if (loader && typeof loader.onUserAction === 'function') {
    loader.onUserAction(function () { loader.require('scripts', 'popup_send_confirmation'); });
  }
  var kicked = false;
  onReady(function () {
    if (kicked || (!POSTED.test(window.location.href) && !hasErrorMarker())) return;
    kicked = true;
    /* The loader listens for these on document; a synthetic one starts the
       same full load a real mouse move would. */
    try { document.dispatchEvent(new Event('mousemove')); } catch (e) {}
  });

  /* ---- focus return after a redirect ------------------------------------- */

  function isNewsletter(form) {
    return !!form.querySelector('input[name="contact[tags]"][value*="newsletter"]');
  }
  function contactForm() {
    var forms = document.querySelectorAll('form[action*="/contact"]');
    for (var i = 0; i < forms.length; i++) {
      if (isNewsletter(forms[i])) continue;
      return forms[i].querySelector('[role="status"], [role="alert"], .ac-contact-form__notice--ok') || forms[i];
    }
    return null;
  }
  function newsletterForm() {
    var forms = document.querySelectorAll('form[action*="/contact"]');
    for (var i = 0; i < forms.length; i++) if (isNewsletter(forms[i])) return forms[i];
    return null;
  }

  function register() {
    if (!window.acDrawerDialog) return false;
    window.acDrawerDialog.register('contact-confirmation', { root: '.ac-cf--contact', close: '.ac-cf__close', returnTo: contactForm });
    window.acDrawerDialog.register('subscription-confirmation', { root: '.ac-cf--newsletter', close: '.ac-cf__close', returnTo: newsletterForm });
    return true;
  }
  register();

  /* ---- accessible name follows the visible block -------------------------- */

  function syncLabel(root) {
    if (!root) return;
    var blocks = root.querySelectorAll('[data-ac-cf-state]');
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].classList.contains('d-none')) continue;
      var title = blocks[i].querySelector('.ac-cf__title');
      var text = blocks[i].querySelector('.ac-cf__text');
      if (title && title.id) root.setAttribute('aria-labelledby', title.id);
      if (text && text.id) root.setAttribute('aria-describedby', text.id); else root.removeAttribute('aria-describedby');
      return;
    }
  }

  function bind() {
    var t = window.theme;
    if (!t || !t.Popups || typeof t.Popups.addHandler !== 'function') return false;
    ['contact-confirmation', 'subscription-confirmation'].forEach(function (name) {
      var sync = function ($popup) { syncLabel($popup && $popup[0] ? $popup[0].querySelector('.ac-cf') : null); };
      t.Popups.addHandler(name, 'call.before', sync);
      t.Popups.addHandler(name, 'call.after', sync);
      /* A confirmation that opened on page load may already be showing. */
      var body = document.querySelector('[data-js-popup-name="' + name + '"]');
      if (body && body.classList.contains('show')) syncLabel(body.querySelector('.ac-cf'));
    });
    return true;
  }

  (function wait(tries) {
    if (bind()) return;
    if (tries > 300) return;
    window.setTimeout(function () { wait(tries + 1); }, 100);
  })(0);
})();
